<template>
  <v-container>
    <div class="d-flex justify-end">
      <v-breadcrumbs :items="breadItems" divider=">"></v-breadcrumbs>
    </div>
    <v-row v-if="object">
      <v-col sm="12" md="4" lg="3">
        <v-card min-height="350px" class="border-radius-10">
          <v-row>
            <v-col cols="12">
              <div class="user-profile">
                <div class="user-profile__avatar">
                  <v-img :src="object.tutor_profile_pic ? object.tutor_profile_pic : 'img/default_user.png'"
                    class="user-profile__photo"></v-img>
                </div>
              </div>

              <div class="user-info">
                <div class="user-info__name">
                  {{ object.tutor_fname }} {{ object.tutor_lname }}
                </div>
                <div class="user-info__email">{{ object.tutor_email }}</div>
                <div class="user-info__phone">{{ object.tutor_contactno }}</div>
              </div>

              <div class="tutor-info">
                <div class="tutor-info__subjects">
                  <v-chip outlined color="primary" v-for="(subject, index) in object.tutor_subject_group" :key="index">
                    {{ subject.subject.subject_name }}
                  </v-chip>
                </div>
                <!-- <div class="tutor-info__rating">
                                    <v-rating
                                    v-model="object.ratting"
                                    background-color="#F2A711 lighten-3"
                                    color="#F2A711"
                                    readonly
                                    dense
                                    medium
                                    ></v-rating>
                                </div> -->
              </div>

              <div class="student-class">
                <div class="student-class__info">
                  <div class="student-class__info-title">Students</div>
                </div>

                <div class="student-class__info-value" v-for="group in computedGroups">
                  <div v-for="student in group.group_student">
                    <router-link class="profile-link" active-class="active" :exact="true"
                      :to="{ name: 'StudentProfile', params: { id: student.student_id } }">
                      {{ student.student.std_fname }} {{ student.student.std_lname }}
                    </router-link>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col sm="12" md="8" lg="9">
        <v-card min-height="100%" class="border-radius-10" style="padding: 12px">
          <v-row style="float: right">
            <!-- <v-col>
              <v-btn
                :loadingTool="loadingTool"
                color="success"
                class="profile-button"
                @click="addTutorToVCTool(object)"
                small
              >
                <!-- <v-icon dark>mdi-plus</v-icon> -->
            <!-- Add To Virtual Tool -->
            <!-- </v-btn>
            </v-col>  -->
            <v-col>
              <v-btn :loading="loading" color="success" class="profile-button" @click="addTutorToVC(object)" small>
                <!-- <v-icon dark>mdi-plus</v-icon> -->
                Add To Virtual class
              </v-btn>
            </v-col>
          </v-row>
          <div style="clear: both"></div>

          <v-row class="box-style">
            <v-col md="6">
              <div class="tutor-details border-right">
                <h2 class="tutor-details__heading">About Tutor</h2>
                <v-simple-table class="tutor-details__table" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th class="item-name">Full Name</th>
                        <td class="item-value text-right">
                          {{ object.tutor_fname }} {{ object.tutor_lname }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Username</th>
                        <td class="item-value text-right">{{ object.tutor_username }}</td>
                      </tr>
                      <tr>
                        <th class="item-name">Email</th>
                        <td class="item-value text-right">{{ object.tutor_email }}</td>
                      </tr>
                      <tr>
                        <th class="item-name">Contact Number</th>
                        <td class="item-value text-right">
                          {{ object.tutor_contactno }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Address</th>
                        <td class="item-value text-right">
                          {{ object.tutor_street_address }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Postcode</th>
                        <td class="item-value text-right">{{ object.tutor_postcode }}</td>
                      </tr>
                      <tr>
                        <th class="item-name">How to deliver the lesson:</th>
                        <td class="item-value text-right">{{ object.lesson_type }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>

            <v-col md="6">
              <div class="tutor-details">
                <h2 class="tutor-details__heading">Earning</h2>
                <v-simple-table class="tutor-details__table" dense>
                  <template v-slot:default>
                    <tbody>
                      <!-- <tr>
                                                <th class="item-name">Week Days</th>
                                                <td class="item-value text-right"><v-chip outlined v-for="(day, index) in object.days" :key="index">{{days_formatter(day)}}</v-chip>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="item-name">Time</th>
                                                <td class="item-value text-right">{{object.time}}
                                                </td>
                                            </tr> -->
                      <tr>
                        <th class="item-name">Per Hour Rate</th>
                        <td class="item-value text-right">
                          {{ object.tutor_per_hour_rate }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <h2 class="tutor-details__heading">Groups And Students</h2>
              <table style="width: 100%; border: 1px solid lightgrey">
                <div v-for="group in object.group">
                  <h5>{{ group.group_name }}</h5>

                  <td v-for="student in group.group_student">
                    {{ student.student.std_fname }} {{ student.student.std_lname }}
                  </td>
                </div>
              </table>
            </v-col>
          </v-row>
          <v-row class="box-style">
            <v-col md="12">
              <div class="tutor-details">
                <h2 class="tutor-details__heading">Bank Details</h2>
                <v-simple-table class="tutor-details__table bank" dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Bank Name</th>
                        <th>Account Title</th>
                        <th>Account Number</th>
                        <th>Sort Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {{ object.tutor_bankname }}
                        </td>
                        <td>
                          {{ object.tutor_account_title }}
                        </td>
                        <td>
                          {{ object.tutor_accountno }}
                        </td>
                        <td>
                          {{ object.tutor_sortcode }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>

          <!-- <v-row>
                        <v-col md="6">
                            <div class="lecture-detail">
                                <h3 class="lecture-detail__title">Delivered</h3>
                                <div class="lecture-detail__box">
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value">34</div>
                                        <div class="lecture-detail__name">Total Lectures</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value">25 hr</div>
                                        <div class="lecture-detail__name">Total Time</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value">£ 300</div>
                                        <div class="lecture-detail__name">Paid Amount</div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col md="6">
                            <div class="lecture-detail">
                                <h3 class="lecture-detail__title">Remaining</h3>
                                <div class="lecture-detail__box remaining">
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value remaining">25</div>
                                        <div class="lecture-detail__name">Total Lectures</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value remaining">20 hr</div>
                                        <div class="lecture-detail__name">Total Time</div>
                                    </div>
                                    <div class="lecture-detail__desc">
                                        <div class="lecture-detail__value remaining">£ 250</div>
                                        <div class="lecture-detail__name">Unpaid Amount</div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Profile",
  components: {},
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loadingTool: false,

      loading: false,
      object: {},
      rating: 4,
      lesson_types: [
        {
          id: 1,
          label: "In-centre",
        },
        {
          id: 2,
          label: "online",
        },
        {
          id: 3,
          label: "Online & In-centre",
        },
      ],
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: "Tutors",
          disabled: false,
          to: {
            name: "Tutors",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
      about: [
        {
          name: "Full Name",
          value: "John Doe",
        },
        {
          name: "Email Address",
          value: "johndoe@gmail.com",
        },
        {
          name: "Contact Number",
          value: "+9203401234567",
        },
        {
          name: "Address",
          value: "House no 123, Street 12, Bahira Orchard, Lahore",
        },
      ],

      schedule: [
        {
          name: "Subjects",
          value: "Computer Science",
        },
        {
          name: "Week days",
          value: "Tues, Thurs, Sunday",
        },
        {
          name: "Time",
          value: "1:00 PM to 3:00 PM",
        },
        {
          name: "Per hour rate",
          value: "£ 25",
        },
      ],

      bank: [
        {
          name: "Subjects",
          value: "Computer Science",
        },
        {
          name: "Week days",
          value: "Tues, Thurs, Sunday",
        },
        {
          name: "Time",
          value: "1:00 PM to 3:00 PM",
        },
        {
          name: "Per hour rate",
          value: "£ 25",
        },
      ],
    };
  },
  computed: {
    computedGroups() {
      let s = new Set();
      let temp = [];
      this.object.group.forEach((group, key) => {
        group.group_student.map((student) => {
          if (!temp.includes(student.student_id)) {
            s.add(group);
            temp.push(student.student_id);
          }
        });
      });
      return Array.from(s);
    },
  },
  methods: {
    addTutorToVC(tutor) {
      this.loading = true;
      axios
        .post("addTutorToVC", tutor)
        .then((response) => {
          this.loading = false;
          // console.log(response.data)
          // this.object = response.data
          swal("Teacher added successfully!");
        })
        .catch((error) => {
          this.loading = false;

          this.overlay = false;
          console.log(error.response);
          swal(error.response.data.message);
        });
    },
    addTutorToVCTool(tutor) {
      this.loadingTool = true;
      axios
        .post("addTutorToVCTool", tutor)
        .then((response) => {
          this.loadingTool = false;
          // console.log(response.data)
          // this.object = response.data
          swal("Teacher added successfully to VC tool!");
        })
        .catch((error) => {
          this.loading = false;

          this.overlay = false;
          console.log(error.response);
          swal(error.response.data.message);
        });
    },

  },
  mounted() {
    axios.get(apiRoutes.tutors.url + "/" + this.id).then((response) => {
      let selectedLesson = this.lesson_types.filter((ls) => {
        if (ls.id == response.data.lesson_type) return ls;
      });
      response.data.lesson_type = selectedLesson[0].label;
      this.object = response.data;
    });
  },
};
</script>

<style lang="scss" scoped>
.box-style {
  border-bottom: 1px dashed #8898aa80;
  margin-bottom: 10px;
}

.border-radius-10 {
  border-radius: 10px;
}

.border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.user-profile {
  height: 160px;
  margin-top: -12px;
  background: #f1efef;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  &__avatar {
    max-height: 120px;
    overflow: hidden;
    width: 120px;
    border-radius: 50%;
    border: 1px solid #6a158e;
    padding: 2px;
    margin-bottom: -20px;
  }
}

.user-info {
  margin-top: 40px;
  text-align: center;

  &__name {
    font: 500 18px/22px Gotham;
    color: #172b4d;
  }

  &__email,
  &__phone {
    font: 400 14px/22px Gotham;
    color: #3f475d99;
  }
}

.tutor-info {
  text-align: center;
  padding: 10px 18px;
  margin-top: 30px;
  border-top: 0.5px solid #d6dbe1;
  // border-left: 0;
  // border-right: 0;
  // border-bottom: 0;

  &__subjects {
    font: 400 15px/25px Gotham;
    color: #6a158e;
  }
}

.tutor-details {
  &__heading {
    font: Bold 20px/25px Lato;
    color: #3f475d;
  }

  &__table {
    margin-top: 10px;

    & th.item-name {
      width: 40%;
      border-bottom: none !important;
      padding-left: 0;
      font: 500 14px/13px Gotham;
      color: #3f475d;
    }

    & td.item-value {
      border-bottom: none !important;
      font: 400 14px/13px Lato;
      color: #3f475d99;
    }

    &.bank {
      & th.item-name {
        width: auto;
      }

      & td.item-value {
        padding-left: 0;
      }
    }
  }
}

.lecture-detail {
  &__title {
    text-align: center;
    font: 500 15px/25px Gotham;
    color: #172b4d;
  }

  &__box {
    padding: 20px 10px;
    border: 1px solid #12a630;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  &__desc {
    text-align: center;
  }

  &__value {
    font: 500 18px/30px Gotham;
    color: #12a630;
  }

  &__name {
    font: 500 10px/13px Gotham;
    color: #3f475d;
  }

  &__box.remaining {
    border-color: #0ebddff7;
  }

  &__value.remaining {
    color: #0ebddff7;
  }
}

.student-class {
  padding: 10px 18px;
  margin-top: 30px;
  border: 0.5px solid #d6dbe1;
  border-left: 0;
  border-right: 0;

  &__info {
    display: flex;
    justify-content: space-between;

    &-title {
      font: 500 14px/20px Gotham;
      color: #172b4d;
    }

    &-value {
      font: 300 14px/13px;
      font-family: "Gotham Narrow";
      color: #8898aa;
    }
  }
}

.student-subjects {
  padding: 10px 18px;
  margin-top: 15px;

  &__btn {
    margin-bottom: 10px;
  }
}
</style>
